
var megaMenuOpen = false;

prepMegaMenu = () => {

  const megaMenuWrapper = document.querySelector('.mega-menu-wrapper');

  if (!megaMenuWrapper) return;

  const previewColumns = megaMenuWrapper.querySelectorAll('.preview-column');
  const previewColumnInners = megaMenuWrapper.querySelectorAll('.preview-column .inner');
  const backdrop = megaMenuWrapper.querySelector('.backdrop');
  let shiftTls = [];

  prepInfiniteMenuCols = () => {

    const windowWidth = getViewport().width;

    if (windowWidth > 767) {
      const wrapperHeight = previewColumns[0].offsetHeight;
      const headerHeight = windowWidth > 767 ? 80 : 70;

      for (let i = 0; i < previewColumns.length; i++) {
        let elParent = previewColumnInners[i].parentElement; // shift-container
        let shiftElBounds = elParent.getBoundingClientRect();
        let el = previewColumnInners[i];

        const colHeight = el.offsetHeight;
        let heightDiff = colHeight - wrapperHeight;
        const colClone = el.cloneNode(true);

        const shiftTL = new gsap.timeline({ paused: true });
        let resetAt;

        let resetTo;
        if (colHeight > wrapperHeight) {
          elParent.appendChild(colClone);
          resetAt = colHeight + heightDiff;
          resetTo = heightDiff;
        } else {

          let colCloneTwo = el.cloneNode(true);
          elParent.appendChild(colClone);
          elParent.appendChild(colCloneTwo);
        }

        let firstDur = Math.round((25 * (resetTo / resetAt)) * 1e4) / 1e4;
        let secondDur = (25 - firstDur);

        shiftTL
          .fromTo(elParent, firstDur, { y: -40 }, { y: -resetTo, ease: Linear.easeNone, force3D: true })
          .add('resetLabel')
          .fromTo(elParent, secondDur, { y: -resetTo }, {
            immediateRender: false, y: -resetAt, ease: Linear.easeNone, force3D: true, onComplete: () => {
              shiftTL.tweenFromTo('resetLabel', shiftTL.totalDuration());
            }
          });

        shiftTls.push(shiftTL);

        if (isMobile()) {
          el.addEventListener('mouseenter', (event) => {
            shiftTL.pause();
          }, false);
          el.addEventListener('mouseleave', (event) => {
            shiftTL.play();
          }, false);
        }
      }
    }
  };

  prepInfiniteMenuCols();

  let header = document.getElementById('header');

  const primaryHoverTargets = header.querySelectorAll('.left li a:not(.nav)');
  const primaryCloseTriggers = megaMenuWrapper.querySelectorAll('.panel.one .close, .backdrop');
  const secondaryCloseTriggers = megaMenuWrapper.querySelectorAll('.panel.two .close');
  const secondaryHoverTargets = megaMenuWrapper.querySelectorAll('.secondary-hovers li');
  const megaMenus = megaMenuWrapper.querySelectorAll('.mega-menu');
  const primaryPanels = megaMenuWrapper.querySelectorAll('.panel.one');
  const secondaryPanels = megaMenuWrapper.querySelectorAll('.panel.two');
  const secondaryPanelWrappers = megaMenuWrapper.querySelectorAll('.secondary-panels');
  const tertiaryHoverTargets = megaMenuWrapper.querySelectorAll('.tertiary-hovers li');
  const tertiaryContent = megaMenuWrapper.querySelectorAll('.tertiary-content');

  let prevPrimaryIdx = 99;
  let prevSecondaryIdx = 99;
  let prevTertiaryIdx = 99;
  let secondaryPanelOpen = false;
  let tertiaryPanelOpen = false;
  let primaryHoverTimeout

  gsap.set(secondaryPanels, { x: -120, autoAlpha: 0, pointerEvents: 'none' });
  gsap.set(megaMenus, { x: -120, autoAlpha: 0, pointerEvents: 'none' });

  megaMenus.forEach((el) => {
    el.addEventListener('click', () => {
      escMegaMenu();
    });
  });

  primaryPanels.forEach((el) => {
    el.addEventListener('click', (e) => {
      e.stopPropagation();
    });
  });

  secondaryPanelWrappers.forEach((el) => {
    el.addEventListener('click', (e) => {
      e.stopPropagation();
    });
  });

  primaryHoverTargets.forEach((el, i) => {

    el.addEventListener("mouseout", () => {
      clearTimeout(primaryHoverTimeout)
    })

    el.addEventListener('mouseenter', () => {

      if (prevPrimaryIdx === i) { return; }

      if (hasClass(el, "no-hover")) {

        escMegaMenu();

        return;
      }

      // Set underline
      primaryHoverTargets.forEach(target => {
        target.classList.remove("active");
      });

      el.classList.add("active");

      // setTimeout to do the other stuff
      // save timeoutID locally
      //on mouseout, clear timeout id
      primaryHoverTimeout = setTimeout(() => {

        // hideSearchTray();

        gsap.to(backdrop, .4, { autoAlpha: 1, ease: Sine.easeInOut, force3D: true });

        if (prevPrimaryIdx !== 99) {
          gsap.set(megaMenus, { autoAlpha: 0, pointerEvents: 'none' });
        }

        prevPrimaryIdx = i;

          console.log("megaMenus[i]", megaMenus[i]);
        
        if (prevSecondaryIdx !== 99) {
          secondaryHoverTargets[prevSecondaryIdx].classList.remove('active');
          gsap.set(secondaryPanels, { x: -100, autoAlpha: 0, pointerEvents: 'none' });
          secondaryPanelOpen = false;
          prevSecondaryIdx = 99;
        }

        if (prevTertiaryIdx !== 99) {
          tertiaryHoverTargets[prevTertiaryIdx].classList.remove('active');
          gsap.set(tertiaryContent, { autoAlpha: 0, pointerEvents: "none" });
          tertiaryPanelOpen = false;
          prevTertiaryIdx = 99;
        }

        if (megaMenuOpen) {
          gsap.set(megaMenus[i], { x: 0, autoAlpha: 1, pointerEvents: 'all' });
        } else {
          megaMenuOpen = true;
          gsap.fromTo(megaMenus[i], 0.7, { autoAlpha: 0, pointerEvents: 'none' }, { autoAlpha: 1, pointerEvents: 'all', ease: Expo.easeOut, force3D: true });
          gsap.fromTo(megaMenus[i], 1.05, { x: -100 }, { x: 0, ease: Expo.easeOut, force3D: true });
        }
      }, 100)
    });
  });

  secondaryHoverTargets.forEach((el, i) => {

    el.addEventListener('mouseenter', () => {

      if (prevSecondaryIdx === i) { return; }

      if (prevSecondaryIdx !== 99) {
        secondaryHoverTargets[prevSecondaryIdx].classList.remove('active');
        gsap.set(secondaryPanels[prevSecondaryIdx], { autoAlpha: 0, x: -70, pointerEvents: 'none' });
      }

      prevSecondaryIdx = i;

      if (prevTertiaryIdx !== 99) {
        tertiaryHoverTargets[prevTertiaryIdx].classList.remove('active');
        gsap.set(tertiaryContent, { autoAlpha: 0, pointerEvents: "none" });
        tertiaryPanelOpen = false;
        prevTertiaryIdx = 99;
      }

      el.classList.add('active');

      if (!secondaryPanelOpen) {
        secondaryPanelOpen = true;
        gsap.fromTo(secondaryPanels[i], 0.6, { autoAlpha: 0, pointerEvents: 'none' }, { autoAlpha: 1, pointerEvents: 'all', ease: Expo.easeOut, force3D: true });
        gsap.fromTo(secondaryPanels[i], 1, { x: -100 }, { x: 0, ease: Expo.easeOut, force3D: true });
      } else {
        gsap.set(secondaryPanels[i], { autoAlpha: 1, x: 0, pointerEvents: 'all' });
      }
    });
  });

  tertiaryHoverTargets.forEach((el, i) => {
    el.addEventListener('mouseenter', () => {
      if (prevTertiaryIdx === i) { return; }
      if (prevTertiaryIdx !== 99) {
        tertiaryHoverTargets[prevTertiaryIdx].classList.remove('active');
        gsap.set(tertiaryContent[prevTertiaryIdx], { autoAlpha: 0, pointerEvents: "none" });

        if (shiftTls[prevTertiaryIdx]) {
          shiftTls[prevTertiaryIdx].pause();
        }
      }
      prevTertiaryIdx = i;
      if (!tertiaryPanelOpen) {
        tertiaryPanelOpen = true;
        if (shiftTls[i]) {
          shiftTls[i].play();
        }
        gsap.fromTo(previewColumns[i], 1.1, { autoAlpha: 0, pointerEvents: 'none' }, { y: 0, autoAlpha: 1, pointerEvents: 'all', ease: Expo.easeOut });
      } else {
        if (shiftTls[i]) {
          shiftTls[i].play();
        }
        gsap.set(tertiaryContent[i], { autoAlpha: 1, y: 0, pointerEvents: "all" });
      }
      el.classList.add('active');
    });

    el.addEventListener('mouseleave', () => {

    });
  });

  primaryCloseTriggers.forEach((el, i) => {
    el.addEventListener('click', () => {
      gsap.to(backdrop, .4, { autoAlpha: 0, ease: Sine.easeOut, force3D: true });
      gsap.to(megaMenus, 1.05, { x: -100, autoAlpha: 0, pointerEvents: 'none', ease: Expo.easeOut, force3D: true });
      if (prevSecondaryIdx !== 99) {
        secondaryHoverTargets[prevSecondaryIdx].classList.remove('active');
        gsap.to(secondaryPanels, 1.05, { x: -100, autoAlpha: 0, pointerEvents: 'none', ease: Expo.easeOut, force3D: true });
      }
      if (prevTertiaryIdx !== 99) {
        tertiaryHoverTargets[prevTertiaryIdx].classList.remove('active');
        gsap.set(tertiaryContent[prevTertiaryIdx], { autoAlpha: 0, pointerEvents: "none" });
        if (shiftTls[prevTertiaryIdx]) {
          shiftTls[prevTertiaryIdx].pause();
        }
      }
      megaMenuOpen = false;
      secondaryPanelOpen = false;
      tertiaryPanelOpen = false;
      prevPrimaryIdx = 99;
      prevSecondaryIdx = 99;
      prevTertiaryIdx = 99;
    });
  });

  secondaryCloseTriggers.forEach((el, i) => {
    el.addEventListener('click', () => {
      if (prevTertiaryIdx !== 99 && shiftTls[prevTertiaryIdx]) {
        gsap.delayedCall(0.37, () => {
          if (shiftTls[prevTertiaryIdx]) {
            shiftTls[prevTertiaryIdx].pause();
          }
        });
      }
      gsap.to(secondaryPanels, 1.05, {
        x: -100, autoAlpha: 0, pointerEvents: 'none', ease: Expo.easeOut, force3D: true, onComplete: () => {
          if (prevTertiaryIdx !== 99) {
            tertiaryHoverTargets[prevTertiaryIdx].classList.remove('active');
            gsap.set(tertiaryContent, { autoAlpha: 0, pointerEvents: "none" });
          }
        }
      });
      if (prevSecondaryIdx !== 99) {
        secondaryHoverTargets[prevSecondaryIdx].classList.remove('active');
      }
      secondaryPanelOpen = false;
      tertiaryPanelOpen = false;
      prevSecondaryIdx = 99;

      // Remove underline
      primaryHoverTargets.forEach(target => {
        target.classList.remove("active");
      })
    });
  });

  escMegaMenu = () => {

    if (secondaryPanelOpen) {
      secondaryCloseTriggers[prevSecondaryIdx].click();
    }

    if (megaMenuOpen) {
      gsap.to(backdrop, 0.4, { autoAlpha: 0, ease: Sine.easeOut, force3D: true });

      if (primaryCloseTriggers[prevPrimaryIdx]) primaryCloseTriggers[prevPrimaryIdx].click();
    }
  };

  reverseMegaMenu = () => {
    primaryCloseTriggers[prevPrimaryIdx].click();
  };

};